import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class RegulationDetailsOperationsResponse {
  @jsonMember readonly canUpdate!: boolean;
  @jsonMember readonly canDelete!: boolean;
  @jsonMember readonly canView!: boolean;
  @jsonMember readonly canPreview!: boolean;
}
